
<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>课程中心</span><span>/</span><span>
        <router-link to="/Company/MyCurriculum" v-if="flag=='2'">自研课程</router-link>
        <router-link to="/Company/BuyCurriculum" v-else>已购课程</router-link>

      </span><span>/</span><span>课程详情</span>
    </div>
    <div class="boughtInfo">
      <div class="boughtInfo-header">
        课程详情
      </div>
      <div class="boughtInfo-content disFlex">
        <div>
          <el-image style="width: 169px; height: 113px;border-radius: 4px;" :src="wjSrc+productInfo.img"></el-image>
        </div>
        <div style="margin-left: 20px;">
          <table class="boughtTable">
            <tr>
              <td class="boughtTd1">标题</td>
              <td colspan="5">{{productInfo.cname}}<el-link v-if="productInfo.producttype=='2'" type="primary" @click="toMx" :underline="true" style="margin-left: 10px;line-height: 17px;">明细</el-link></td>
            </tr>
            <tr>
              <td class="boughtTd1">培训类目</td>
              <td>{{productInfo.ontypeName}}</td>
              <td class="boughtTd1">课时</td>
              <td>{{productInfo.ksyq}}</td>
              <td class="boughtTd1">价格</td>
              <td>{{flag=='2'?'-/-':'￥'+(productInfo.price*productInfo.dnbuyamount)}}</td>
            </tr>
            <tr>
              <td class="boughtTd1">购买数量</td>
              <td>{{flag=='2'?'-/-':productInfo.dnbuyamount}}</td>
              <td class="boughtTd1">报名人数</td>
              <td>{{productInfo.appUsers?productInfo.appUsers.length:0}}</td>
              <td class="boughtTd1">有效期</td>
              <td>{{productInfo.endtime?productInfo.endtime.substring(0,10):''}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="boughtInfo">
      <div class="boughtInfo-header between">
        <div>报名信息</div>
        <div style="height: 36px;">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="">
              <el-input v-model="formInline.keyword" placeholder="请输入姓名/ID查询" suffix-icon="el-icon-search"></el-input>
            </el-form-item>
            <el-form-item label="" style="width: 130px;" v-if="flag!='2'">
              <el-select v-model="formInline.kstate" clearable placeholder="全部状态">
                <el-option label="通过" value="0"></el-option>
                <el-option label="未通过" value="1"></el-option>
                <el-option label="未考试" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="boughtInfo-content">
        <el-table :data="productInfo.appUsers?getSearchData(productInfo.appUsers):[]" style="width: 100%"
          max-height="250" v-if="flag=='2'">
          <el-table-column prop="stuid" label="ID">
          </el-table-column>
          <el-table-column prop="avatarurl" label="头像">
            <template slot-scope="scope">
              <el-avatar size="medium" :src="getTxurl(scope.row)"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="姓名">
          </el-table-column>
          <el-table-column prop="sex" label="性别">
          </el-table-column>
          <el-table-column prop="age" label="年龄">
          </el-table-column>
          <el-table-column prop="phone" label="电话">
          </el-table-column>
          <el-table-column prop="id" label="档案">
            <template slot-scope="scope">
              <el-button type="success" size="mini" @click="toDangan(scope.row.id)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="productInfo.appUsers?getSearchData(productInfo.appUsers):[]" style="width: 100%"
          max-height="250" v-else>
          <el-table-column prop="stuid" label="ID">
          </el-table-column>
          <el-table-column prop="avatarurl" label="头像" width="70">
            <template slot-scope="scope">
              <el-avatar size="medium" :src="getTxurl(scope.row)"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="姓名" width="100">
          </el-table-column>
          <el-table-column prop="sex" label="性别" width="70">
          </el-table-column>
          <el-table-column prop="age" label="年龄" width="70">
          </el-table-column>
          <el-table-column prop="phone" label="电话">
          </el-table-column>
          <el-table-column prop="score" label="考试分数">
          </el-table-column>
          <el-table-column prop="kstime" label="考试时间">
          </el-table-column>
          <el-table-column prop="kstate" label="考试状态">
          </el-table-column>
          <el-table-column prop="id" label="档案">
            <template slot-scope="scope">
              <el-button type="success" size="mini" @click="toDangan(scope.row.id)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
          :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper"
          :total="productInfo.appUsers?productInfo.appUsers.length:0">
        </el-pagination>

      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        circleUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        formInline: {
          keyword: '',
          kstate: '',
          rows: 10,
          page: 1
        },
        productInfo: {},
        tableData: {
          rows: [],
          total: 0
        },
        txnanUrl: require('@/assets/images/notxnan.png'),
        txnvUrl: require('@/assets/images/notxnv.png'),
        txnoUrl: require('@/assets/images/nosex.png'),
        txadminUrl: require('@/assets/images/notxsex.png'),
        flag: ''
      }
    },
    methods: {
      getData: function(id) {
        this.$axios.get('/kt/wz/productInfo/getProdcutallDetail.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.productInfo = data.data;

          } else {
            this.$message.error(data.message);
          }
        })
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      getTxurl: function(item) {
        if (item.avatarurl) {
          return this.wjSrc + item.avatarurl
        } else if (item.sex == '女') {
          return this.txnvUrl
        } else if (item.sex == '男') {
          return this.txnanUrl
        } else if (item.roleCode == "COM_ADMIN_AQKT") {
          return this.txadminUrl
        } else {
          return this.txnoUrl
        }
      },
      getSearchData: function(rows) {
        var list = [];
        rows.map((item) => {
          // 两个搜索条件
          if (this.formInline.keyword && this.formInline.kstate) {
            if ((item.realName.includes(this.formInline.keyword) || item.stuid.includes(this.formInline
              .keyword)) && item.kstate == this.formInline.kstate) {
              list.push(item)
            }
          } else if (this.formInline.keyword) {
            if (item.realName.includes(this.formInline.keyword) || item.stuid.includes(this.formInline.keyword)) {
              list.push(item)
            }
          } else if (this.formInline.kstate) {
            if (item.kstate == this.formInline.kstate) {
              list.push(item)
            }
          } else {
            list.push(item)
          }
        })
        return list;
      },
      toDangan:function(id){
        this.$router.push('/Company/ArchivesInfo?id=' + id);
      },
      toMx:function(){
        // 跳转明细清单
        this.$router.push('/Company/Mingxi?id=' + this.productInfo.id+'&flag='+this.flag);
      }
    },
    created: function() {
      // 课程详情
      if (this.$route.query.id) {
        this.getData(this.$route.query.id);
        this.flag = this.$route.query.flag;
      }
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          console.log(val)
        },
        deep: true //true 深度监听
      }
    },
  }
</script>
<style>
  .boughtInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .boughtInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
  }

  .boughtInfo-content {
    padding: 20px;
  }

  .boughtTable {
    line-height: 38px;
    text-align: left;
    font-size: 14px;
  }

  .boughtTable td {
    padding-left: 20px;
    width: 140px;
    border: 1px solid #efefef;
  }

  .boughtTd1 {
    height: 38px;
    background-color: #f6f6f6;
    width: 105px;

  }
</style>



// WEBPACK FOOTER //
// src/components/company/CurseInfo.vue